import { z } from '@bonanza-social/toolkit/api';

export const UploadKYCDocsSchema = z.object({}).optional();
